// extracted by mini-css-extract-plugin
module.exports = {"asideContent":"style-module_asideContent_3rbGb","empty":"style-module_empty_3GMwY","pointer":"style-module_pointer_2JfpA","asideMinimizer":"style-module_asideMinimizer_2l7Jn"};